"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dropdownSelectStyles_1 = require("./dropdownSelectStyles");
var clsx_1 = require("clsx");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var useCheckoutContext_1 = require("../../../../../gql/common/hooks/useCheckoutContext");
var dxpDigitalDataAssignment_1 = require("../../../../../../../common/utilities/dxpDigitalDataAssignment");
var customDatalayerInterface_1 = require("../../../../../../../common/utilities/customDatalayerInterface");
var dxpProducts_1 = require("../../../../../../../common/constants/dxpProducts");
var dxpDataLayerHandler_1 = require("../../../../common/utils/dxpDataLayerHandler");
var JourneyStepsRoutes_1 = require("../../../../../gql/checkout4/enum/JourneyStepsRoutes");
var DropdownSelect = function (_a) {
    var formData = _a.formData;
    var styles = dropdownSelectStyles_1.default();
    var _b = formData.options, inputLabel = _b.inputLabel, enumOptions = _b.enumOptions, label = formData.label, id = formData.id, required = formData.required, value = formData.value, onChange = formData.onChange, placeholder = formData.placeholder, formContext = formData.formContext, disabled = formData.disabled, readOnly = formData.schema.readOnly;
    var _c = react_1.useState(enumOptions), enumOptionsList = _c[0], setEnumOptionsList = _c[1];
    var platformConfig = usePlatformConfig_1.default().platformConfig;
    var deal = useCheckoutContext_1.default().deal;
    react_1.useEffect(function () {
        if (id === 'root_location_dealer' && formContext.availableDealers.length) {
            setEnumOptionsList(formContext.availableDealers);
        }
    }, [formContext.availableDealers]);
    // TODO: find nicer way to fix it XPD-1248, XPD-20261
    react_1.useEffect(function () {
        setEnumOptionsList(enumOptions);
    }, [enumOptions]);
    if (id === 'root_housing_housingDistrict') {
        window.addEventListener('root_housing_housingDepartment_change', function () {
            setEnumOptionsList([]);
        });
    }
    if (id === 'root_provinceRegionDistrict_province') {
        window.addEventListener('root_provinceRegionDistrict_region_change', function () {
            setEnumOptionsList([]);
        });
    }
    var handleChange = function (e) {
        var _a;
        if (id === 'root_housing_housingDepartment') {
            window.dispatchEvent(new Event('root_housing_housingDepartment_change'));
        }
        if (id === 'root_provinceRegionDistrict_region') {
            window.dispatchEvent(new Event('root_provinceRegionDistrict_region_change'));
        }
        if (id === 'root_regionDealer_dealerSelect' && ((_a = platformConfig) === null || _a === void 0 ? void 0 : _a.dxpDataLayer)) {
            dxpDigitalDataAssignment_1.default(__assign(__assign({ event: customDatalayerInterface_1.DxpDataLayerEvent.CONFIGURATOR, eventName: customDatalayerInterface_1.DxpDataLayerEventNames.CNF_DEALERS_CLICKED, pageTitle: document.title, DXPProduct: dxpProducts_1.default.checkout, dealerPreference: e.target.value || '' }, dxpDataLayerHandler_1.formatDataLayerDeal(deal)), { nextSteps: dxpDataLayerHandler_1.getSaveEnquiryFormNextSteps(), stepName: JourneyStepsRoutes_1.JourneyStepsRoutes.DEALER.replace('/', '') }));
        }
        onChange(e.target.value);
    };
    return (<core_1.Box className={styles.fieldWrapper}>
      {inputLabel !== false && (<core_1.Typography variant={'subtitle1'} data-test={"dropdown_select:label:" + id} className={styles.hideSalutation}>
          <core_1.InputLabel className={styles.label} htmlFor={id} required={required}>
            {label}
          </core_1.InputLabel>
        </core_1.Typography>)}
      <core_1.Select id={id} className={clsx_1.default(styles.select, !value && styles.itemDisabled)} disabled={!!readOnly || disabled} labelId={id} value={value || '-1'} label={label} variant="outlined" data-test={"dropdown_select:" + id} onChange={handleChange} classes={{
        root: styles.root,
        select: styles.select,
        outlined: styles.outlined,
        disabled: styles.disabled,
    }}>
        {!!placeholder && (<core_1.MenuItem value={'-1'} disabled={true} classes={{
        root: clsx_1.default(styles.itemDisabled),
    }}>
            {placeholder}
          </core_1.MenuItem>)}
        {enumOptionsList ? (enumOptionsList
        .filter(function (option) { return option.value; })
        .map(function (option, index) {
        var _a, _b, _c;
        return (<core_1.MenuItem key={index} value={(_a = option) === null || _a === void 0 ? void 0 : _a.value} data-test={"enquiry_form:dropdown_select:option:" + ((_b = option) === null || _b === void 0 ? void 0 : _b.label)} classes={{
            root: styles.item,
        }}>
                  {(_c = option) === null || _c === void 0 ? void 0 : _c.label}
                </core_1.MenuItem>);
    })) : (<core_1.MenuItem />)}
      </core_1.Select>
    </core_1.Box>);
};
exports.default = DropdownSelect;
